export const queryKeys = {
  MESSAGE_LIST: 'MESSAGE_LIST',
  TEMPLATE_MESSAGE: 'TEMPLATE_MESSAGE',
  PREMIUM_ORIGINATOR: 'PREMIUM_ORIGINATOR',
  TEMPLATE_MESSAGE_FIELDS: 'TEMPLATE_MESSAGE_FIELDS'
};
